import gql from "graphql-tag";

export const CHANGE_PW_QUERY = gql`
  mutation ChangePasswordMutation(
    $oldPassword: String!
    $newPassword: String!
  ) {
    updateUserPassword(newPassword: $newPassword, oldPassword: $oldPassword) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/ChangePassword/queries.ts